import { Box } from "@mui/material";
import styles from "../StructuredPromptImageCanvas.module.scss";
import { ResizeHandle } from "../types";

const HANDLE_SIZE = 10;

const getHandleCursor = (handle: ResizeHandle): string => {
	switch (handle) {
		case "nw":
		case "se":
			return "nwse-resize";
		case "ne":
		case "sw":
			return "nesw-resize";
		default:
			return "default";
	}
};

interface ResizeHandlesProps {
	bbox: { left: number; top: number; width: number; height: number };
	onMouseDown: (e: React.MouseEvent, handle: ResizeHandle) => void;
}

export const ResizeHandles = ({ bbox, onMouseDown }: ResizeHandlesProps) => {
	const { left, top, width, height } = bbox;
	const handles: ResizeHandle[] = ["nw", "ne", "sw", "se"];

	return (
		<>
			{handles.map((handle) => (
				<Box
					key={handle}
					className={styles.resizeHandle}
					style={{
						left:
							handle === "nw" || handle === "sw"
								? `${left - HANDLE_SIZE / 2}px`
								: `${left + width - HANDLE_SIZE / 2}px`,
						top:
							handle === "nw" || handle === "ne"
								? `${top - HANDLE_SIZE / 2}px`
								: `${top + height - HANDLE_SIZE / 2}px`,
						cursor: getHandleCursor(handle),
					}}
					onMouseDown={(e) => {
						e.stopPropagation();
						onMouseDown(e, handle);
					}}
				/>
			))}
		</>
	);
};
